import { Button, Card } from '@/components/common'

interface QuickActionCardProps {
  title: string
  description: string
  onClick: () => void
}

export function QuickActionCard({ title, description, onClick }: QuickActionCardProps) {
  return (
    <Card className="hover:shadow-lg transition-shadow">
      <div className="p-6 flex flex-col h-full">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-sm text-gray-600 mb-4 flex-1">{description}</p>
        <Button onClick={onClick} variant="primary" className="w-full">
          Öffnen
        </Button>
      </div>
    </Card>
  )
}
